import { all, call, fork, put, takeEvery, select, delay } from 'redux-saga/effects';
import { osName, browserName, browserVersion } from 'react-device-detect';
// @ts-ignore - import from .js file
import * as ActionTypes from 'constants/ActionTypes';

import {
  showAuthMessage,
  userSignInSuccess,
  userSignOutSuccess,
  resetPasswordSuccess,
  userVerifySuccess,
  verifyOTPSuccess,
  changeWorkShiftSuccess,
  authProcessSuccess,
  hideMessage,
  hideAuthLoader,
  showAuthLoader,
  resetProcessStatus,
  checkSessionSuccess,
  userSignOut,
} from '../actions/Auth';
import { systemConfigDataSourceUpdate } from '../actions/setup/systemSetup/systemConfig';
import { systemBannerSet, systemBannerReset } from '../actions/systemBanner';
import { switchLanguage } from '../actions/setting-actions';
import languageData from '../../containers/Topbar/languageData';
import { APIPostRequest, APIGetRequest } from 'util/connection';
import { API_URL_AUTH, API_HEADERS } from 'constants/ApiSetting';
import { setItems, getItems, removeItems } from 'util/custom';
import { removeItemsBySession } from 'util/localStorage';
import { IndexedDBOpen, IndexedDBDeleteDatabase } from 'util/indexedDBLibrary';
import { DataStore } from 'constants/DataStore';
//import { notificationPreview} from "appRedux/actions/Notifications"
import { stateSet } from 'constants/StateDefault';

import { REQUEST_RESET_USER_URL } from 'constants/ConstantsVariable';
import { notifyAuthChanged, notifyAuthLogout } from 'util/authChannel';
import { notificationPreview } from '../actions';

const AT = ActionTypes as any;

export const getAuthUser = (state: any) => state.auth;

/**
 * Convert language code (e.g., "TH", "EN") to locale object from languageData
 * @param languageCode - Language code from API response (e.g., "TH", "EN", "ZH")
 * @returns Locale object matching languageData structure, or null if not found
 */
const getLocaleFromLanguageCode = (languageCode: string | null | undefined): any => {
  if (!languageCode) return null;

  // Normalize language code to lowercase
  const normalizedCode = languageCode.toLowerCase();

  // Find matching locale in languageData
  const matchedLocale = languageData.find((lang) => lang.locale.toLowerCase() === normalizedCode);

  return matchedLocale || null;
};

function* signInWithUserAndPassword({ payload }: any): any {
  try {
    yield put(showAuthLoader());
    yield IndexedDBDeleteDatabase('ListBoxDB');

    const URL = `${API_URL_AUTH}auth/login/`;
    const { username, password } = payload;
    /* Split username case get prop_code */
    const splitUsername = username.split('@'); //your_username@your_prop_code

    // @ts-ignore
    delete API_HEADERS.headers.Authorization;
    let deviceId = localStorage.getItem('DEVICE_ID');
    if (!deviceId) {
      deviceId = crypto.randomUUID();
      localStorage.setItem('DEVICE_ID', deviceId);
    }
    const deviceInfo = `${osName} - ${browserName} V.${browserVersion} - ${deviceId}`;
    const API_DATABODY = {
      prop_code: splitUsername[1],
      username: splitUsername[0],
      password: password,
      device: deviceInfo,
      renew_session: false,
    };

    const resSignIn = yield call(APIPostRequest, URL, API_DATABODY, API_HEADERS);
    const { status, data } = resSignIn;

    if (status === 200) {
      const {
        system_config: { system_params },
      } = data;
      const systemDate = system_params?.SYSTEM?.SYSTEM_DATE;
      localStorage.setItem('SYSTEM_DATE', systemDate); // Optional: store in localStorage
      // yield put(updateSystemDate(systemDate)); // <-- if you create such an action

      setItems({ access_token: data.access_token });
      notifyAuthChanged(data.access_token, data, system_params, deviceId);

      // Get language from response data and update locale
      const languageCode = data?.language || data?.user_language || null;
      const localeObject = getLocaleFromLanguageCode(languageCode);

      // Prepare effects array
      const effects = [
        put(hideAuthLoader()),
        put(userSignInSuccess(data, true)),
        put(systemConfigDataSourceUpdate(system_params)),
      ];

      // If locale found, add switchLanguage action and update localStorage
      if (localeObject) {
        localStorage.setItem('locale', JSON.stringify(localeObject));
        effects.push(put(switchLanguage(localeObject)));
      }

      const systemAlert = data?.system_alerts ?? null
      if (systemAlert !== null) {
        const resolveItem = (item: any) => item ? { type: item.type, message: item.message ?? '' } : null
        effects.push(put(systemBannerSet({
          system: resolveItem(systemAlert.system ?? null),
          property: resolveItem(systemAlert.property ?? null),
        })))
      } else {
        effects.push(put(systemBannerReset()))
      }

      /*  run multiple Effects in parallel and wait for all of them to complete */
      yield all(effects);

      yield IndexedDBOpen('ListBoxDB', DataStore);
    } else {
      const { message } = data;
      removeItems(['access_token', stateSet]);
      yield put(showAuthMessage(message));
      yield put(hideAuthLoader());
    }
  } catch (error) {
    removeItems(['access_token', stateSet]);
    yield put(showAuthMessage(error));
    yield put(hideAuthLoader());
  }
}

// function* verifyTokenProcess({payload}) {
// try {
//   const  { access_token }  = yield call(getItems, ['access_token'])
//   const url =  `${API_URL_AUTH}auth/verify/?access_token=${access_token}&grant_type=information_user`
//   // API_PMS_HEADERS.headers.Authorization = `Bearer ${access_token}`
//   delete API_HEADERS.headers.Authorization
//   const response = yield APIGetRequest(url,API_HEADERS)
//   if(response.status === 200){
//       const dataResponse = response.data
//       yield put(userSignInSuccess(dataResponse))
//       yield put(notificationPreview())
//   }else{
//     const {message, data} = response.data
//     yield put(showAuthMessage(message))
//     if(response.status === 403){
//       /* if data is not null force signout */
//       if(data)
//         yield put(userSignOut())
//     }
//   }
// } catch (error) {
//   yield put(showAuthMessage(error))
// }
// }

function* signOut(): any {
  const { access_token } = yield call(getItems, ['access_token']);
  const AuthUser = yield select(getAuthUser);
  const log_id = AuthUser.authUser ? AuthUser.authUser.log_id : 0;

  if (log_id === 0) {
    removeItems(['access_token', stateSet]);
    localStorage.clear();
    removeItemsBySession(['report_active_menu_category']);
    sessionStorage.clear();
    yield put(userSignOutSuccess());
  } else {
    try {
      const URL = `${API_URL_AUTH}auth/logout/`;
      API_HEADERS.headers.Authorization = `${process.env.REACT_APP_ACCESS_TOKEN_TYPE} ${access_token}`;
      const API_DATABODY = { log_id: log_id };

      yield call(APIPostRequest, URL, API_DATABODY, API_HEADERS);
      //Remove all Item Storage
      removeItems(['access_token', stateSet]);
      localStorage.clear();
      removeItemsBySession(['report_active_menu_category']);
      sessionStorage.clear();

      notifyAuthChanged(null, null, null, null);
      yield put(userSignOutSuccess());
    } catch (error) {
      // yield put(showAuthMessage(error))
    }
  }
}

function* verifyUserProcess({ payload }: any): any {
  try {
    const URL = `${API_URL_AUTH}auth/otp/generate/`;
    const { otp_option, user, action } = payload;
    const splitUsername = user.split('@');
    const grantType = action === 'activate' ? 'activate_user' : 'forgot_password';
    let receivedBy = '';
    let sentTo = '';
    if (otp_option === 'email') {
      receivedBy = 'email';
      sentTo = payload.email;
    } else {
      receivedBy = 'phone';
      sentTo = payload.mobile;
    }

    const API_DATABODY = {
      grant_type: grantType,
      info: {
        prop_code: splitUsername[1],
        user_name: splitUsername[0],
        received_by: receivedBy,
        to: sentTo,
      },
    };
    // @ts-ignore
    delete API_HEADERS.headers.Authorization;

    const response = yield call(APIPostRequest, URL, API_DATABODY, API_HEADERS);
    if (response.status === 200) {
      yield put(userVerifySuccess(response.data));
    } else {
      yield put(showAuthMessage(response.data.message));
    }
  } catch (error) {
    yield put(showAuthMessage(error));
  }
}

function* verifyOTPProcess({ payload }: any): any {
  try {
    const URL = `${API_URL_AUTH}auth/otp/verify/`;
    const { otp_number, secret_key } = payload;

    const API_DATABODY = {
      secret_key: secret_key,
      otp_number: otp_number,
    };
    // @ts-ignore
    delete API_HEADERS.headers.Authorization;

    const response = yield call(APIPostRequest, URL, API_DATABODY, API_HEADERS);
    if (response.status === 200) {
      yield put(verifyOTPSuccess(response.data));
    } else {
      yield put(showAuthMessage(response.data.message));
    }
  } catch (error) {
    yield put(showAuthMessage(error));
  }
}

function* resetPasswordProcess({ payload }: any): any {
  try {
    const URL = `${API_URL_AUTH}auth/user/resetPassword/`;
    const { password, uid, action, gt } = payload;
    const grantType = action === 'OTP' ? gt : 'activate_user';

    const API_DATABODY = {
      grant_type: grantType,
      code_reset: uid,
      new_password: password,
    };

    // @ts-ignore
    delete API_HEADERS.headers.Authorization;

    const response = yield call(APIPostRequest, URL, API_DATABODY, API_HEADERS);
    if (response.status === 200) {
      yield put(resetPasswordSuccess());
    } else {
      yield put(showAuthMessage(response.data.message));
    }
  } catch (error) {
    yield put(showAuthMessage(error));
  }
}

function* changeWorkShiftProcess({ payload }: any): any {
  try {
    const { workShift, user_id, prop_id } = payload;

    const { access_token } = yield call(getItems, ['access_token']);
    const AccessToken = access_token;

    const API_DATABODY = { user_id, prop_id, new_shift: workShift };
    API_HEADERS.headers.Authorization = `Bearer ${AccessToken}`;
    const URL = `${API_URL_AUTH}auth/user/changeWorkShift/`;
    const response = yield APIPostRequest(URL, API_DATABODY, API_HEADERS);
    if (response.status === 200) {
      yield put(changeWorkShiftSuccess(workShift));
    } else {
      const message = response.status === 404 ? '404 Not found' : response.message;
      const processStatus = {
        status: false,
        action: 'authChangeWorkShift',
        message: message || '',
      };
      yield put(authProcessSuccess(processStatus));
      yield delay(100);
    }
  } catch (error: any) {
    const processStatus = {
      status: false,
      action: 'authChangeWorkShift',
      message: error,
    };
    yield put(authProcessSuccess(processStatus));
    yield delay(100);
  }
}

function* requestResetUserProcess({ payload }: any): any {
  try {
    const URL = `${API_URL_AUTH}${REQUEST_RESET_USER_URL}`;
    const { action_type, user_name, email } = payload;

    const API_DATABODY = {
      action_type: action_type,
      user_name: user_name,
      email: email,
    };

    // @ts-ignore
    delete API_HEADERS.headers.Authorization;

    const response = yield call(APIPostRequest, URL, API_DATABODY, API_HEADERS);
    if (response.status === 200) {
      const { res_code = '', res_msg = '' } = response || {};
      const processStatus = {
        status: true,
        action: 'userRequestReset',
        message: res_msg || '',
        res_code,
      };
      yield put(authProcessSuccess(processStatus));
      yield delay(200);
    }
  } catch (error) {
    yield put(showAuthMessage(error));
    yield delay(1000);
    yield put(hideMessage());
  }
}

function* checkSessionProcess({ payload }: any): any {
  try {
    const AuthUser = yield select(getAuthUser);
    const userGroupType = AuthUser?.authUser?.user_group_type || '';
    const propID = AuthUser?.authUser?.prop_id || '';
    const { access_token } = yield call(getItems, ['access_token']);

    if (!userGroupType || !propID || !access_token) {
      yield put(checkSessionSuccess({ valid: true, navigatePath: payload }));
      return;
    }

    const URL = `${API_URL_AUTH}auth/user/?user_group_type=${userGroupType}&prop_id=${propID}`;
    API_HEADERS.headers.Authorization = `Bearer ${access_token}`;

    const response = yield call(APIGetRequest, URL, API_HEADERS);
    const { status, data } = response;

    // Check JSON body status (not HTTP status)
    if (status === 403 || data?.status === 403) {
      // if data is not null force signout
      if (data?.data !== undefined && data?.data !== null) {
        yield put(
          checkSessionSuccess({
            valid: false,
            message: data?.message || 'Already logged out',
            navigatePath: null,
          })
        );
        return;
      }
    }

    // Session is valid
    yield put(checkSessionSuccess({ valid: true, navigatePath: payload }));
  } catch (error) {
    console.error('[Auth Saga] checkSessionProcess error:', error);
    // On error, still allow navigation
    yield put(checkSessionSuccess({ valid: true, navigatePath: payload }));
  }
}

/* Watcher Saga */
export function* signInUserAndPass() {
  yield takeEvery(AT.SIGNIN_USER, signInWithUserAndPassword);
}

export function* signOutUser() {
  yield takeEvery(AT.SIGNOUT_USER, signOut);
}

export function* resetPassword() {
  yield takeEvery(AT.RESET_PASSWORD, resetPasswordProcess);
}

export function* verifyUser() {
  yield takeEvery(AT.VERIFY_USER, verifyUserProcess);
}

export function* verifyOTP() {
  yield takeEvery(AT.VERIFY_OTP, verifyOTPProcess);
}

export function* changeWorkShift() {
  yield takeEvery(AT.CHANGE_WORK_SHIFT, changeWorkShiftProcess);
}

export function* requestResetUser() {
  yield takeEvery(AT.REQUEST_RESET_USER, requestResetUserProcess);
}

export function* checkSession() {
  yield takeEvery(AT.CHECK_SESSION, checkSessionProcess);
}

export default function* rootSaga() {
  yield all([
    fork(signOutUser),
    fork(signInUserAndPass),
    fork(resetPassword),
    fork(verifyUser),
    fork(verifyOTP),
    fork(changeWorkShift),
    fork(requestResetUser),
    fork(checkSession),
  ]);
}
